export default __webpack_public_path__ + "3b2eb3d4c7ad0905fbe9e553d84ed695.png";